import { Star } from "lucide-react";

export function Stars({ value = 0, size = "w-4 h-4", className = "" }) {
  return (
    <span className={`inline-flex gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`} data-testid="stars">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`${size} ${n <= value ? "fill-[#DD6B33] text-[#DD6B33]" : "fill-slate-200 text-slate-200"}`} />
      ))}
    </span>
  );
}

const LABELS = ["", "Disappointing", "Could be better", "Good", "Great", "Outstanding"];

export function StarPicker({ value, onChange, hover, setHover }) {
  const shown = hover || value;
  return (
    <div data-testid="star-picker">
      <div className="flex gap-2">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n} type="button" onClick={() => onChange(n)}
            onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)}
            className="transition-transform duration-150 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#DD6B33]"
            aria-label={`${n} star${n > 1 ? "s" : ""}`} data-testid={`star-${n}`}
          >
            <Star className={`w-11 h-11 sm:w-14 sm:h-14 transition-colors duration-150 ${n <= shown ? "fill-[#DD6B33] text-[#DD6B33]" : "fill-slate-100 text-slate-300"}`} />
          </button>
        ))}
      </div>
      <div className="h-6 mt-2 font-mono text-[11px] tracking-[0.22em] uppercase text-slate-500" data-testid="star-label">
        {shown ? LABELS[shown] : "Tap a star to rate"}
      </div>
    </div>
  );
}
